<template>
  <div class="case">
    <div class="case-header">
      <img
        src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/case-header-0.png"
        alt=""
      />
      <img
        src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/case-header-1.png"
        alt=""
      />
      <img
        src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/case-header-2.png"
        alt=""
      />
      <img
        src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/case-header-3.png"
        alt=""
      />
      <img
        src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/case-header-4.png"
        alt=""
      />
      <img
        src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/case-header-5.png"
        alt=""
      />
      <img
        src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/case-header-6.png"
        alt=""
      />
      <img
        src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/case-header-7.png"
        alt=""
      />
      <img
        src="https://fishawk-client.oss-cn-shenzhen.aliyuncs.com/nbyy/case-header-8.png"
        alt=""
      />
    </div>
    <div class="case-title">{{ isChinese ? `加入我们` : `Join Us` }}</div>
    <div class="case-body">
      <el-card v-for="job in jobList" :key="job.title">
        <div class="job-card">
          <h3 class="job-title">{{ job.title }}</h3>
          <div class="salary">{{ job.salary }}</div>
          <div class="tags">
            <el-tag
              v-for="(tag, tagIndex) in job.tags"
              :key="tagIndex"
              type="info"
              class="job-tag"
            >
              {{ tag }}
            </el-tag>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["isChinese"]),
    jobList() {
      return [
        {
          title: this.isChinese ? "副总经理" : "Deputy General Manager",
          salary: this.isChinese ? "薪资面议" : `Salary Negotiable`,
          tags: [
            this.isChinese ? "管理能力" : `Management ability`,
            this.isChinese ? "3年以上经验" : `More than 3 years of experience`,
            this.isChinese ? "优秀沟通能力" : `Excellent communication skills`,
            this.isChinese ? "本科及以上学历" : `Bachelor degree and above`,
          ],
        },
        {
          title: this.isChinese ? "销售经理" : `Sales Manager`,
          salary: this.isChinese ? "薪资面议" : `Salary negotiable`,
          tags: [
            this.isChinese ? "销售思维" : "Sales mindset",
            this.isChinese ? "3年以上经验" : `More than 3 years of experience`,
            this.isChinese ? "优秀沟通能力" : `Excellent communication skills`,
            this.isChinese ? "本科及以上学历" : `Bachelor degree and above`,
          ],
        },
        {
          title: this.isChinese
            ? "渔业大数据工程师"
            : "Fishery Big Data Engineer",
          salary: this.isChinese ? "薪资面议" : `Salary negotiable`,
          tags: [
            this.isChinese ? "3年以上经验" : `More than 3 years of experience`,
            this.isChinese ? "数据分析能力" : `Data analysis capability`,
            this.isChinese ? "研究生学历" : "Postgraduate degree",
          ],
        },
        {
          title: this.isChinese
            ? "海洋遥感工程师"
            : "Marine Remote Sensing Engineer",
          salary: this.isChinese ? "薪资面议" : `Salary negotiable`,
          tags: [
            this.isChinese ? "3年以上经验" : `More than 3 years of experience`,
            this.isChinese ? "本科及以上学历" : `Bachelor degree and above`,
          ],
        },
      ];
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.case-header {
  display: flex;
  flex-wrap: wrap;
  img {
    width: calc(100% / 3);
  }
}
.case-title {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 120px;
  font-size: 40px;
  font-weight: bold;
  font-style: italic;
  color: rgb(4, 109, 209);
}
.case-body {
  width: 100%;
  box-sizing: border-box;
  padding: 0 calc((100% - var(--breakpoint-x)) / 2);
  min-width: var(--breakpoint-z);
  margin: 50px 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 40px;
}
.job-cards-container-row {
  display: flex;
  justify-content: space-around;
}
.job-title {
  color: rgb(10, 113, 210);
  margin-bottom: 20px;
}
.job-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: flex-start;
}
.salary {
  font-weight: bold;
  margin-bottom: 20px;
  color: rgb(10, 113, 210);
}
.job-tag {
  color: rgb(10, 113, 210);
  background-color: rgb(217, 233, 255);
  margin-right: 20px;
}
.el-card {
  width: calc((100% - 280px) / 2) !important;
}
.el-tag {
  margin-bottom: 10px;
}
@media (max-width: 1300px) {
  .case-body {
    padding: 0 50px;
    margin-top: 100px;
  }
  .el-card {
    width: calc((100% - 180px) / 2) !important;
  }
}
@media (max-width: 768px) {
  .el-card {
    width: 100% !important;
  }
}
</style>